  // Video Reviews JS
document.addEventListener('DOMContentLoaded', function () {
 
  
  /******VIDEO PLAYING FUNCTIONALITY*****/
  const playtriggers = document.querySelectorAll("[playtrigger]");
  playtriggers.forEach(function (playButton) {
    playButton.addEventListener("click", function () {
      debugger;
      const video = this.closest("[videowrapper]").querySelector("video");
      video.play();
      this.classList.add("hidden");
    });
  });

  const videoElements = document.querySelectorAll("[videowrapper] video");
  videoElements.forEach(function (video) {
    video.addEventListener("click", function () {
      debugger;
      if (!this.paused && !this.ended) {
        this.pause();
        this.closest("[videowrapper]").querySelector("[playtrigger]").classList.remove("hidden");
      }
    });

    video.addEventListener("ended", function () {
      const playButton = this.closest("[videowrapper]").querySelector("[playtrigger]");
      playButton.classList.remove("hidden");
      this.load();
    });
  });
});


// document.addEventListener('DOMContentLoaded', function () {

//   // Video Play Functionality
//   const playTriggers = document.querySelectorAll(".playtrigger");
//   playTriggers.forEach(function (playButton) {
//     playButton.addEventListener("click", function () {
//       const video = this.closest(".videowrapper").querySelector("video");
//       if (video) {
//         video.play();
//         this.classList.add("hidden");
//       }
//     });
//   });

//   const videoElements = document.querySelectorAll(".videowrapper video");
//   videoElements.forEach(function (video) {
//     video.addEventListener("click", function () {
//       if (!this.paused && !this.ended) {
//         this.pause();
//         const playButton = this.closest(".videowrapper").querySelector(".playtrigger");
//         if (playButton) {
//           playButton.classList.remove("hidden");
//         }
//       }
//     });

//     video.addEventListener("ended", function () {
//       const playButton = this.closest(".videowrapper").querySelector(".playtrigger");
//       if (playButton) {
//         playButton.classList.remove("hidden");
//       }
//       this.load();
//     });
//   });
// });


// document.addEventListener("DOMContentLoaded", function() {
//     document.querySelectorAll(".random-color").forEach(function(element) {
//       // Generate a random color in hexadecimal format
//       const randomColor = '#' + Math.floor(Math.random()*16777215).toString(16);
//       element.style.backgroundColor = randomColor;
//     });
//   });

document.addEventListener("DOMContentLoaded", function() {
document.querySelectorAll(".random-light-color").forEach(function(element) {
      // Generate a random light color by setting higher minimum values for RGB
      const randomColor = 'rgb(' + 
        (Math.floor(Math.random() * 128) + 128) + ',' +  // Red: 128-255
        (Math.floor(Math.random() * 128) + 128) + ',' +  // Green: 128-255
        (Math.floor(Math.random() * 128) + 128) + ')';   // Blue: 128-255
      element.style.backgroundColor = randomColor;
    });
});
